<script setup lang="ts">
import { toRef } from 'vue';
import { ParticipationState } from '@/store/consultation.interface';
import { Locales } from '@/store/language.interface';
import useResponsive from '@/utils/responsive-util';
import GuidedConsultationProgressBarDesktop from '@/components/GuidedConsultationProgressBarDesktop.vue';
import GuidedConsultationProgressBarMobile from '@/components/GuidedConsultationProgressBarMobile.vue';

const props = defineProps<{
  participationState: ParticipationState;
  languageEnabled: Locales[];
}>();

const emit = defineEmits<{
  (e: 'navigateToForm', formId: number, sectionOrderNum: number): void;
  (e: 'submit'): void;
}>();

const { isMobile } = useResponsive();
</script>

<template>
  <GuidedConsultationProgressBarDesktop
    v-if="!isMobile"
    :participation-state="participationState"
    :language-enabled="languageEnabled"
    @navigate-to-form="(id, orderNum) => emit('navigateToForm', id, orderNum)"
    @submit="emit('submit')"
  />
  <GuidedConsultationProgressBarMobile
    v-else
    :participation-state="participationState"
    :language-enabled="languageEnabled"
    @navigate-to-form="(id, orderNum) => emit('navigateToForm', id, orderNum)"
    @submit="emit('submit')"
  />
</template>
